const SCENARIO_OPTIONS = [
  { label: "سناریو A", value: "A", color: "geekblue" },
  { label: "سناریو B", value: "B", color: "cyan" },
  { label: "سناریو C", value: "C", color: "magenta" },
  { label: "سناریو نصب اپ D", value: "D", color: "orange" },
  { label: "سناریو نقشه دوم", value: "second_roadmap", color: "purple" },
];

const SCENARIO_MAP = Object.fromEntries(
  SCENARIO_OPTIONS.map((s) => [s.value, s]),
);

const mergeScenario = (scenarios, scenario) => {
  const current = scenarios || [];
  if (!scenario || current.includes(scenario)) return current;
  return [...current, scenario];
};

export { SCENARIO_OPTIONS, SCENARIO_MAP, mergeScenario };
